import { ActivityIndicator, View } from "react-native"
import { useLocalSearchParams } from "expo-router"

import { trpc } from "@src/utils"
import { ar } from "@src/i18n/ar"
import { Header, InventoryCollectionForm, Text } from "@src/components"

export default function EditInventoryCollections() {
  const params = useLocalSearchParams<{ id: string }>()
  const id = Number.parseInt(params.id, 10)

  const collection = trpc.inventoryCollections.get.useQuery({ id })

  if (collection.isLoading) {
    return (
      <>
        <Header title={ar.editInventoryCollections} />
        <ActivityIndicator className="mt-6" />
      </>
    )
  }

  if (!collection.data) {
    return (
      <>
        <Header title={ar.editInventoryCollections} />
        <View className="flex-1 justify-center items-center">
          <Text className="text-gray-500">{ar.inventoryCollectionNotFound}</Text>
        </View>
      </>
    )
  }

  return (
    <>
      <Header title={ar.editInventoryCollections} />
      <InventoryCollectionForm id={id} />
    </>
  )
}
